import { render, staticRenderFns } from "./AddNewItem.vue?vue&type=template&id=c6ebdb96&scoped=true&"
import script from "./AddNewItem.vue?vue&type=script&lang=js&"
export * from "./AddNewItem.vue?vue&type=script&lang=js&"
import style0 from "./AddNewItem.vue?vue&type=style&index=0&id=c6ebdb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ebdb96",
  null
  
)

export default component.exports